export const CustomUploadAction = {
    Ready: "custom.upload.ready",
    Language: "custom.upload.language",
    File: "custom.upload.file",
};
